import React from 'react';
import { useIntl } from 'react-intl';
import { styled } from '@compiled/react';

import { token } from '@atlaskit/tokens';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const InputContainer = styled.input({
	height: '30px',
	padding: token('space.050'),
	border: `${token('border.width')} solid ${token('color.border')}`,
	// eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
	borderRadius: token('radius.small', '3px'),
	boxSizing: 'border-box',
	font: token('font.body'),
	width: '100%',
});

export const LazyCommentEditorPlaceholder = (): React.JSX.Element => {
	const intl = useIntl();
	return (
		<div>
			<InputContainer
				disabled
				placeholder={intl.formatMessage({
					id: 'comment.reply.placeholder',
					defaultMessage: 'Reply',
					description:
						'The text is shown as placeholder text inside the comment reply input field before the user starts typing, indicating that the field is used to write a reply to an existing comment.',
				})}
			/>
		</div>
	);
};
